<div class="dropdown user_notification d-none d-md-block" dropdown autoClose="outside">
    <button title="Sync Offline Forms" class="btn btn-white px-2 notification-btn" type="button"
        [disabled]="isSyncing" (click)="syncData()">
        @if(isSyncing){
        <img src="assets/images/sync-cloud-green.svg" alt="Syncing..." width="28" height="28"
            style="animation: spin 1s linear infinite;" />
        }
        @else if(hasOfflineForms){
        <img src="assets/images/sync-cloud-green.svg" alt="Sync Available" width="28" height="28" />
        }
        @else{
        <img src="assets/images/sync-cloud.svg" alt="No Offline Forms" width="28" height="28" />
        }
    </button>
</div>